import { NavLink } from 'react-router-dom';
import { FileText, GitBranch, ListChecks, Send, Users } from 'lucide-react';
import { cn } from '../../lib/cn';

const VOCI = [
  { a: '/mailing/campagne', etichetta: 'Campagne', icona: Send },
  { a: '/mailing/sequenze', etichetta: 'Sequenze', icona: GitBranch },
  { a: '/mailing/modelli', etichetta: 'Modelli', icona: FileText },
  { a: '/mailing/contatti', etichetta: 'Contatti', icona: Users },
  { a: '/mailing/liste', etichetta: 'Liste', icona: ListChecks },
];

/**
 * Le cinque schede della sezione Mailing.
 * Sta qui e non nel menu laterale per non allungarlo con voci quasi uguali:
 * dal menu si entra nella sezione, dentro ci si muove.
 *
 * Sono linguette con la riga sotto, non bottoni pieni: il rosso pieno resta
 * ai pulsanti che fanno qualcosa (Nuova campagna, Importa), cosi' non si
 * confonde "dove sono" con "cosa posso fare".
 */
export function EmailNav() {
  return (
    <nav aria-label="Schede Mailing" className="border-b border-gray-200">
      <div className="flex -mb-px">
        {VOCI.map(({ a, etichetta, icona: Icona }) => (
          <NavLink
            key={a}
            to={a}
            className={({ isActive }) =>
              cn(
                // Stessa larghezza per tutte: la linguetta attiva non cambia
                // forma, cambia solo colore.
                // Sul telefono cinque linguette stanno in riga solo con il testo piu' piccolo.
                'flex-1 sm:flex-none sm:w-36 inline-flex items-center justify-center gap-2 px-1 sm:px-2 py-3',
                'rounded-t-md border-b-2 text-xs sm:text-sm font-medium whitespace-nowrap transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-inset',
                isActive
                  ? 'border-primary-600 bg-primary-50 text-primary-700'
                  : 'border-transparent text-neutral-500 hover:bg-gray-100 hover:text-neutral-800 hover:border-gray-300'
              )
            }
          >
            <Icona className="hidden sm:block w-4 h-4" />
            {etichetta}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
